import CreativeBenchmarkPanel from '../components/creative/CreativeBenchmarkPanel.vue'

import type { ReportLayoutConfig } from '@/features/reports'

// v3 `configs/CreativePerformance/Benchmark.js`: the component section is retained in the
// registry for ownership/discovery, while BenchmarkPage supplies its required date/dimension props
// through ReportPage's bespoke composition slot.
export const BENCHMARK: ReportLayoutConfig = [
  {
    name: 'Benchmark',
    labelKey: 'commerceAnalytics.benchmark.title',
    defaultPreset: 'Last 30 Days',
    selectablePresets: ['Last 7 Days', 'Last 14 Days', 'Last 30 Days', 'Last 60 Days'],
    sections: [
      {
        id: '6-benchmark',
        component: CreativeBenchmarkPanel,
        reportId: 66,
        hiddenCompare: true,
        tabs: [
          {
            name: 'Tiktok',
            channel: 'tiktok_ads',
            reportId: 66,
            tabs: ['tiktok_ads_ad'],
          },
        ],
      },
    ],
  },
]
